const ProductViewPageModel = {
    type: 'page',
    name: 'product',
    blocks: [
        {
            name: 'breadcrumbs',
            type: 'link',
        },
        {
            name: 'product', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'product', // || text || link || image || mixed (with children)
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'description',
            max: 1,
            type: 'html',
        },
        {
            name: 'composition',
            max: 1,
            type: 'html',
        },
        {
            name: 'nutritional-values', // Valeurs nutritionnelles
            max: 1,
            type: 'html',
        },
        {
            name: 'shipping-info-sup',
            max: 1,
            type: 'html',
        },
        {
            name: 'conservation', // references a panel slug, e.g. conservation-saucisson (default model)
            max: 1,
            type: 'panel',
        },
        {
            name: 'faq', // references one or more FAQ panel slugs, e.g. faq-saucisson, faq-fuet-catalan
            type: 'panel',
        },
        {
            name: 'voucher-info',
            max: 1,
            type: 'panel',
        },
        {
            name: 'recommandation',
            max: 1,
            type: 'panel',
        },
        {
            name: 'hideRecommandation', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'toggle', // || text || link || image || mixed (with children)
        },
        {
            name: 'associated-products',
            type: 'product',
        },
        {
            name: 'autoRedirectToCart', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'toggle', // || text || link || image || mixed (with children)
        },
    ],
};

export default ProductViewPageModel;
